export enum SecurityClassificationId {
  OFFICIAL_OPEN = '1',
  OFFICIAL_CLOSED = '2',
  RESTRICTED = '3',
  CONFIDENTIAL = '4',
  SECRET = '5',
}
